import { render } from "./Xcxnav.vue?vue&type=template&id=4cc0268f&scoped=true"
import script from "./Xcxnav.vue?vue&type=script&lang=js"
export * from "./Xcxnav.vue?vue&type=script&lang=js"

import "./Xcxnav.vue?vue&type=style&index=0&id=4cc0268f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc0268f"]])

export default __exports__